<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-container fluid>
    <v-row>
      <v-col cols="9" lg="10">
        <v-row v-if="tabIndex !== 0">
          <v-col v-if="unitedInverterSolra.PVPCS_Vdc === '0.0'" cols="2">
            <gauge-chart
              :flag="refreshFlag"
              color="#0784f2"
              title="입력전압"
              :max="unitedInverterSolra.Umppt2"
              :value="unitedInverterSolra.Umppt2"
              unit="V"
            ></gauge-chart>
            <!--            <v-img src="@/assets/image/pc/sun.jpg" alt="" max-width="201" max-height="162"/>-->
          </v-col>
          <v-col v-else cols="2">
            <gauge-chart
              :flag="refreshFlag"
              color="#0784f2"
              title="입력전압"
              :max="unitedInverterSolra.PVPCS_Vdc"
              :value="unitedInverterSolra.PVPCS_Vdc"
              unit="V"
            ></gauge-chart>
            <!--            <v-img src="@/assets/image/pc/sun.jpg" alt="" max-width="201" max-height="162"/>-->
          </v-col>
          <v-col cols="2">
            <gauge-chart
              :flag="refreshFlag"
              color="#0784f2"
              title="입력전류"
              :max="unitedInverterSolra.PVPCS_Idc"
              :value="unitedInverterSolra.PVPCS_Idc"
              unit="A"
            ></gauge-chart>
          </v-col>
          <v-col cols="2">
            <gauge-chart
              :flag="refreshFlag"
              color="#0784f2"
              title="입력전력"
              :max="unitedSolra.PVPCS_Pcs_Capa"
              :value="unitedInverterSolra.PVPCS_Pdc"
              unit="KW"
            ></gauge-chart>
          </v-col>
          <v-col class="d-flex flex-column">
            <v-simple-table dense class="text-center mb-10">
              <template v-slot:default>
                <tr class="pa-2">
                  <th class="pa-1">상</th>
                  <th class="pa-1">출력 전압</th>
                  <th class="pa-1">출력 전류</th>
                  <th class="pa-1">주파수</th>
                </tr>
                <tr>
                  <td class="pa-1">R</td>
                  <td class="pa-1">{{unitedInverterSolra.PVPCS_Vrs}} V</td>
                  <td class="pa-1">{{unitedInverterSolra.PVPCS_Ir}} A</td>
                  <td class="pa-1" rowspan="3">{{unitedInverterSolra.PVPCS_Fac}} Hz</td>
                </tr>
                <tr>
                  <td class="pa-1">S</td>
                  <td class="pa-1">{{unitedInverterSolra.PVPCS_Vst}} V</td>
                  <td class="pa-1">{{unitedInverterSolra.PVPCS_Is}} A</td>
                </tr>
                <tr>
                  <td class="pa-1">T</td>
                  <td class="pa-1">{{unitedInverterSolra.PVPCS_Vtr}} V</td>
                  <td class="pa-1">{{unitedInverterSolra.PVPCS_It}} A</td>
                </tr>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="2">
            <gauge-chart
              :flag="refreshFlag"
              color="#6ead00"
              title="출력전력"
              :max="unitedSolra.PVPCS_Pcs_Capa"
              :value="unitedInverterSolra.PVPCS_Pac"
              unit="KW"
            ></gauge-chart>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="d-flex justify-center" cols="2">
            <v-img src="@/assets/pc/dashimg01.png" alt max-width="201" max-height="162"/>
          </v-col>
          <v-col class="d-flex flex-column">
            <p class="text-h6 txt-blue font-weight-medium">입력전력 ▼</p>
            <img class="my-3" src="@/assets/image/pc/listing.gif" alt height="10">
            <p class="text-end">
              <span class="text-h2 txt-blue font-weight-medium">{{unitedSolra.PVPCS_Pdc}}</span>
              <span>kW</span>
            </p>
          </v-col>
          <v-col class="d-flex justify-center" cols="2">
            <v-img src="@/assets/pc/dashimg02.png" alt max-width="201" max-height="162"/>
          </v-col>
          <v-col class="d-flex flex-column">
            <p class="text-h6 txt-green font-weight-medium">출력전력 ▲</p>
            <img class="my-3" src="@/assets/image/pc/listing.gif" alt height="10">
            <p class="text-end">
              <span class="text-h2 txt-green font-weight-medium">{{unitedSolra.PVPCS_Pac}}</span>
              <span>kW</span>
            </p>
          </v-col>
          <v-col class="d-flex justify-center" cols="2">
            <v-img src="@/assets/pc/dashimg03.png" alt max-width="201" max-height="162"/>
          </v-col>
        </v-row>
        <v-row class="align-center">
          <v-col cols="12" lg="4">
            <v-tabs v-model="tabNo" fixed-tabs>
              <v-tab>일 발전량(시간)</v-tab>
              <v-tab>월 발전량</v-tab>
              <v-tab>연 발전량</v-tab>
            </v-tabs>
          </v-col>
          <v-spacer v-show="$vuetify.breakpoint.lgAndUp"></v-spacer>
          <v-col class="d-flex" cols="12" lg="6">
            <v-btn
              outlined
              small
              class="align-self-center excel_down mr-4"
              @click="excelDown"
            >엑셀 다운로드</v-btn>
            <span class="align-self-center mr-4" v-show="isDayWork">당일 발전량 : {{dayWork}}</span>
            <date-picker :date.sync="startDate"></date-picker>
            <v-btn outlined small class="align-self-center default-btn mx-4" @click="searchChart">조회</v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" class="pa-0">
            <v-container class="pa-0" fluid>
              <v-chart autoresize style="width:100%;height: 200px;" :option="chartOption"></v-chart>
              <v-divider class="my-5"></v-divider>
              <real-grid
                ref="workStateDataGrid"
                class="mt-1 mb-5 w-full"
                :options="grid.gridOption"
                :fields="grid.gridFields"
                :columns="grid.gridColumns"
                :height="grid.height"
                :retrieve-api="gridRetrieveApi"
              ></real-grid>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" lg="2">
        <img v-if="tabIndex !== 0" src="@/assets/image/pc/site_pcs.jpg" alt>
        <v-card v-else elevation="0" min-width="288">
          <v-card-text>
            <v-row>
              <v-col class="font-weight-medium pl-1 pr-0">당월예상 누적금액</v-col>
              <v-col cols="7 text-right">
                <span class="big_txt">{{solraPrice.sumPrice}}</span>
                <span>원</span>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <div v-if="solraPrice.isFit !== '1'">
              <v-row>
                <v-col class="py-0 font-weight-medium">REC</v-col>
                <v-col class="py-0 text-right">
                  <span class="font-weight-medium">{{solraPrice.recPrice}}</span>
                  <span>원</span>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col class="py-0 font-weight-medium">SMP</v-col>
                <v-col class="py-0 text-right">
                  <span class="font-weight-medium">{{solraPrice.smpPrice}}</span>
                  <span>원</span>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <div
                class="text-caption"
                v-show="true"
              >* REC 단가({{solraPrice.rec/1000}}원), SMP단가({{solraPrice.smp}}원) 기준</div>
            </div>
            <span class="text-caption">* 실제금액은 변동될 수 있습니다.</span>
          </v-card-text>
        </v-card>
        <v-list two-line outlined class="py-0">
          <div v-for="item in rightTableItem" :key="item.title">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  <span class="big_txt">{{ item.value }}</span>
                  <span :style="item.style">{{ item.unit }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </div>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePicker from '@/components/monitoring/DatePicker'
import GaugeChart from '@/components/monitoring/GaugeChart'
import RealGrid from '@/components/grid/Realgrid'

import {
  getSolraUnitedInverterWork,
  getSolraInverterDayWork,
  getSolraInverterMonthWork,
  getSolraInverterYearWork,
  getSolraUnitedWork,
  getSolraDayWork,
  getSolraMonthWork,
  getSolraYearWork,
  getSMPMonthAvgPrice,
  getSiteYesterday
} from '@/api/pcs/siteWork'

import day from 'dayjs'

import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart } from 'echarts/charts'
import {
  DataZoomComponent,
  ToolboxComponent,
  GridComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  TooltipComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import { use } from 'echarts/core'

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  DataZoomComponent,
  ToolboxComponent,
  GridComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  TooltipComponent
])
// 스크립트를 정의하는 부분
// 개발자 작업 영역

let interval_workState

export default {
  name: 'WorkState',
  components: {
    VChart,
    DatePicker,
    GaugeChart,
    RealGrid
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  props: {
    tabIndex: {
      type: Number,
      default: -1
    },
    SITE_ID: { type: String, default: 'M0149' },
    STATION_ID: { type: String, default: '0001' },
    INVERTER_ID: { type: String, default: 'PVPCS01' },
    changeToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: '',
      updateUniteSolra: false,
      inverter: '',
      refreshFlag: 1,
      solraPrice: {
        sumPrice: '0',
        smpPrice: '0',
        recPrice: '0',
        rec: 34350,
        smp: 80.56
      },
      tabNo: 0,
      calendar: false,
      startDate: day(new Date()).format('YYYY-MM-DD'),
      barItems: [],
      lineItems: [],
      bar: {
        xAxis: {
          type: 'category',
          data: ['a', 'b', 'c', 'd', 'e']
        },
        grid: {
          x: 35,
          y: 20,
          y2: 25,
          x2: 25
        },
        legend: {
          textStyle: {
            color: 'rgba(188, 188, 188, 1)'
          }
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: function(value) {
                if (value >= 1000) {
                  return value / 1000 + 'k'
                }
                return value
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(204,204,204,0.5)'
              }
            }
          },
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} h'
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(204,204,204,0.5)'
              }
            },
            minInterval: 1,
            maxInterval: 35
          }
        ],
        series: [
          {
            name: '발전량',
            data: [1, 2, 3, 4, 5],
            type: 'bar'
          }, {
            name: '발전시간',
            data: [1, 2, 3, 4, 5],
            yAxisIndex: 1,
            type: 'line'
          }
        ],
        tooltip: {
          trigger: 'axis'
        }
      },
      unitedSolra: {
        PVPCS_Pdc: 0,
        PVPCS_Pac: 0,
        PVPCS_Daily_P: '',
        PVPCS_Day: '',
        PVPCS_CurrentMonth_P: '',
        PVPCS_Month: 0,
        PVPCS_AfterMonth_P: '',
        PVPCS_Total_P: ''
      },
      unitedInverterSolra: {},
      tempYesterdayData: [],
      isDayWork: true,
      dayWork: 111,
      itemsPerPage: 50,
      tabValue: [
        {
          series: [
            '05:00',
            '05:20',
            '05:40',
            '06:00',
            '06:20',
            '06:40',
            '07:00',
            '07:20',
            '07:40',
            '08:00',
            '08:20',
            '08:40',
            '09:00',
            '09:20',
            '09:40',
            '10:00',
            '10:20',
            '10:40',
            '11:00',
            '11:20',
            '11:40',
            '12:00',
            '12:20',
            '12:40',
            '13:00',
            '13:20',
            '13:40',
            '14:00',
            '14:20',
            '14:40',
            '15:00',
            '15:20',
            '15:40',
            '16:00',
            '16:20',
            '16:40',
            '17:00',
            '17:20',
            '17:40',
            '18:00',
            '18:20',
            '18:40',
            '19:00',
            '19:20',
            '19:40',
            '20:00',
            '20:20',
            '20:40',
            '21:00',
            '21:20',
            '21:40'
          ]
        },
        {
          series: [
            '01일',
            '02일',
            '03일',
            '04일',
            '05일',
            '06일',
            '07일',
            '08일',
            '09일',
            '10일',
            '11일',
            '12일',
            '13일',
            '14일',
            '15일',
            '16일',
            '17일',
            '18일',
            '19일',
            '20일',
            '21일',
            '22일',
            '23일',
            '24일',
            '25일',
            '26일',
            '27일',
            '28일',
            '29일',
            '30일',
            '31일'
          ]
        },
        {
          series: [
            '1월',
            '2월',
            '3월',
            '4월',
            '5월',
            '6월',
            '7월',
            '8월',
            '9월',
            '10월',
            '11월',
            '12월'
          ]
        }
      ],
      grid: {
        height: 442.5,
        gridOption: {
          gridView: {
            edit: {
              editable: false
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            fixed: {
              rowCount: 1
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            rowIndicator: {
              visible: false
            },
            stateBar: {
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridTotal: 0,
        gridFields: [
          { fieldName: 'runTime', dataType: 'string' },
          { fieldName: 'runData', dataType: 'string' },
          { fieldName: 'runDataTotal', dataType: 'string' },
          { fieldName: 'runHour', dataType: 'string' },
          { fieldName: 'runHourTotal', dataType: 'string' }
        ],
        gridColumns: [
          {
            name: 'runTime',
            fieldName: 'runTime',
            header: {
              text: '시간'
            },
            styles: {
              textAlignment: 'center'
            },
            width: 50
          },
          {
            name: 'runData',
            fieldName: 'runData',
            header: {
              text: '발전량'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'runDataTotal',
            fieldName: 'runDataTotal',
            header: {
              text: '누적 발전량'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'runHour',
            fieldName: 'runHour',
            header: {
              text: '발전시간'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'runHourTotal',
            fieldName: 'runHourTotal',
            header: {
              text: '누적 발전시간'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          }
        ]
      }
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
    this.stopTimer()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  watch: {
    SITE_ID(newValue) {
      getSiteYesterday(this.SITE_ID).then(res => {
        this.tempYesterdayData = res
      })
      this.initChart()
      this.initTable(this.tabNo)
      this.initChartData()
      this.startTimer()
    },
    tabNo(newValue) {
      this.initChart()
      this.initTable(this.tabNo)
      this.initChartData()
      let runHour = '발전시간'
      let runHourTotal = '누적 발전시간'
      if (this.tabNo === 2) {
        // 연발전량 탭일경우 탭명 변경
        runHour = '일평균발전시간'
        runHourTotal = '누적 일평균발전시간'
      }

      let runHourText = this.$refs.workStateDataGrid
        .getGridView()
        .getColumnProperty('runHour', 'header')
      let runHourTotalText = this.$refs.workStateDataGrid
        .getGridView()
        .getColumnProperty('runHourTotal', 'header')
      runHourText.text = runHour
      runHourTotalText.text = runHourTotal

      this.$refs.workStateDataGrid
        .getGridView()
        .setColumnProperty('runHour', 'header', runHourText)
      this.$refs.workStateDataGrid
        .getGridView()
        .setColumnProperty('runHourTotal', 'header', runHourTotalText)
    },
    tabIndex(newValue) {
      this.updateUniteSolra = false
      this.startTimer()
      this.initChart()
      this.initChartData()
    },
    changeToggle() {
      // 내부 중간탭이 변경됐을때
      this.refreshFlag++
    }
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    gridRetrieveApi() {
      return this.initChartData
    },
    chartOption() {
      let a = this.bar
      a.xAxis.data = this.tabValue[this.tabNo].series
      if (this.tabNo === 0) {
        // 일발전량 탭일경우
        a.series[1].name = '발전시간'
        a.series[1].data = this.lineItems
      } else if (this.tabNo === 1) {
        // 월발전량 탭일경우
        a.series[1] = {
          name: '발전시간',
          data: [1, 2, 3, 4, 5],
          yAxisIndex: 1,
          type: 'line'
        }
        a.series[1].data = this.lineItems
      } else if (this.tabNo === 2) {
        // 년발전량 탭일경우
        a.series[1] = {
          name: '일평균발전시간',
          data: [1, 2, 3, 4, 5],
          yAxisIndex: 1,
          type: 'line'
        }
        a.series[1].data = this.lineItems
      }
      a.series[0].data = this.barItems
      return a
    },
    yesterdayData() {
      if (this.tempYesterdayData.length > 0) {
        if (this.tabIndex === 0) {
          let totalDP = 0
          let totalDT = 0
          for (let item of this.tempYesterdayData) {
            totalDP += item.PVPCS_Daily_P
          }

          if (this.updateUniteSolra) {
            return {
              PVPCS_Daily_P: totalDP.toFixed(1),
              Daily_Time: (
                totalDP /
                (this.unitedSolra.PVPCS_Pcs_Capa === undefined
                  ? 1
                  : this.unitedSolra.PVPCS_Pcs_Capa)
              ).toFixed(1)
            }
          } else {
            return {
              PVPCS_Daily_P: totalDP.toFixed(1),
              Daily_Time: 0
            }
          }
        } else {
          let temp = this.tempYesterdayData[this.tabIndex - 1]
          return {
            PVPCS_Daily_P: temp.PVPCS_Daily_P.toFixed(1),
            Daily_Time: temp.Daily_Time.toFixed(1)
          }
        }
      } else {
        return {
          PVPCS_Daily_P: 0,
          Daily_Time: 0
        }
      }
    },
    rightTableItem() {
      return [
        {
          title: '일간 누적 발전량',
          value: this.unitedSolra.PVPCS_Daily_P,
          unit: 'kWh'
        },
        {
          title: '일간 누적 발전시간',
          value: this.unitedSolra.PVPCS_Day,
          unit: 'h',
          style: 'padding-right: 20px'
        },
        {
          title: '전일발전량',
          unit: 'kWh',
          value: this.yesterdayData.PVPCS_Daily_P
        },
        {
          title: '전일 발전시간',
          unit: 'h',
          value: this.yesterdayData.Daily_Time,
          style: 'padding-right: 20px'
        },
        {
          title: '당월 발전량',
          value: this.unitedSolra.PVPCS_CurrentMonth_P,
          unit: 'kWh'
        },
        {
          title: '당월 발전 시간',
          value: this.unitedSolra.PVPCS_Month,
          unit: 'h',
          style: 'padding-right: 20px'
        },
        {
          title: '전월 누적 발전량',
          value: this.unitedSolra.PVPCS_AfterMonth_P,
          unit: 'kWh'
        },
        {
          title: '총 누적 발전량',
          value: this.unitedSolra.PVPCS_Total_P,
          unit: 'kWh'
        },
        {
          title: '평균 발전시간',
          value: (
            parseFloat(
              this.unitedSolra.PVPCS_CurrentMonth_P.replaceAll(',', '')
            ) /
            this.unitedSolra.PVPCS_Pcs_Capa /
            this.date
          ).toFixed(1),
          unit: 'h',
          style: 'padding-right: 20px'
        }
      ]
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    initChart() {
      this.barItems = []
      this.lineItems = []
    },
    initTable(index) {
      // 0 일 , 1 월, 2 년
      let data = []
      data.push({
        runTime: '평균',
        runData: 0,
        runDataTotal: '-',
        runHour: 0,
        runHourTotal: '-'
      })
      this.tabValue[index].series.forEach(item => {
        data.push({
          runTime: item,
          runData: 0,
          runDataTotal: 0,
          runHour: 0,
          runHourTotal: 0
        })
      })
      this.$refs.workStateDataGrid.getDataProvider().fillJsonData(data)
    },
    searchChart() {
      this.initChart()
      this.initTable(this.tabNo)
      this.$refs.workStateDataGrid.retrieve()
    },
    excelDown() {
      this.$refs.workStateDataGrid.excelDown(this.startDate)
    },
    initChartData() {
      if (this.tabIndex === 0) {
        let today = new Date()
        this.date = today.getDate()
        let params = '?site_id=' + this.SITE_ID
        getSolraUnitedWork(params).then(res => {
          this.unitedSolra = res.unitedSiteInfo
          // this.solraPrice = res.smpInfo
          this.updateUniteSolra = true
          if (this.tabNo === 0) {
            this.getSolraDayWorkTabTotal()
            this.isDayWork = true
          } else if (this.tabNo === 1) {
            this.getSolraMonthWorkTabTotal()
            this.isDayWork = false
          } else if (this.tabNo === 2) {
            this.getSolraYearWorkTabTotal()
            this.isDayWork = false
          }
        })
        getSMPMonthAvgPrice(params).then(res => {
          this.solraPrice = res
        })
      } else {
        let params =
          '?site_id=' +
          this.SITE_ID +
          '&station_id=' +
          this.STATION_ID +
          '&inverter_id=' +
          this.INVERTER_ID
        getSolraUnitedInverterWork(params)
          .then(res => {
            this.unitedSolra = res.unitedSiteInfo
            this.unitedInverterSolra = res.unitedSiteInfo
            this.refreshFlag++
            if (this.tabNo === 0) {
              this.getSolraDayWorkTab()
              this.isDayWork = true
            } else if (this.tabNo === 1) {
              this.getSolraMonthWorkTab()
              this.isDayWork = false
            } else if (this.tabNo === 2) {
              this.getSolraYearWorkTab()
              this.isDayWork = false
            }
          })
          .catch(res => {
            console.log('에러')
            this.unitedSolra = {
              PVPCS_Daily_P: 0,
              PVPCS_Day: 0,
              PVPCS_CurrentMonth_P: '',
              PVPCS_Month: 0,
              PVPCS_AfterMonth_P: 0,
              PVPCS_Total_P: 0,
              PVPCS_Pcs_Capa: 1
            }
            this.unitedInverterSolra = {
              PVPCS_Pac: 0,
              PVPCS_It: 0,
              PVPCS_Vtr: 0,
              PVPCS_Is: 0,
              PVPCS_Vst: 0,
              PVPCS_Fac: 0,
              PVPCS_Ir: 0,
              PVPCS_Vrs: 0,
              PVPCS_Pdc: 0,
              PVPCS_Idc: 0,
              PVPCS_Vdc: 0
            }

            this.refreshFlag++
          })
      }
    },
    startTimer() {
      this.stopTimer()
      this.inverter = setInterval(() => {
        this.initChartData()
      }, 60000 * 2)
    },
    stopTimer() {
      clearInterval(this.inverter)
    },
    getSolraDayWorkTab() {
      let params =
        '?site_id=' +
        this.SITE_ID +
        '&station_id=' +
        this.STATION_ID +
        '&inverter_id=' +
        this.INVERTER_ID +
        '&startDate=' +
        this.startDate
      getSolraInverterDayWork(params).then(res => {
        // this.barItems = res.solraDayWork.runData

        // this.dayWork = res.solraDayWork.sumValData
        let datas = []
        let runDataTotal = 0
        let runData = 0
        let runTime = res.solraDayWork.runTime
        let runHourTotal = 0
        let runHour = 0
        let barData = []
        let lineHours = []
        let count = 0 // 0 아닌 데이터 카운트

        for (let index = 0; index < runTime.length; index++) {
          let runTimeRp = Number(runTime[index].replace(/:/gi, '')) // ex) 05:00 --> 0500
          barData.push(res.solraDayWork.runData[index].toFixed(1))
          runData += res.solraDayWork.runData[index] // 발전량
          runDataTotal += res.solraDayWork.runData[index] // 누적발전량
          lineHours.push((runData / this.unitedSolra.PVPCS_Pcs_Capa).toFixed(1))
          // ex) 05:50, 06:50 등 다음 시간으로 넘어가기 전 push
          // 20.02.06 AHJ 20분 간격으로 정책 변경에 따라 50->40으로 변경
          if (runTime[index].substr(3) === '40') {
            // 발전시간 추가
            if (runData.toFixed(1) > 0) {
              if (this.unitedSolra.PVPCS_Pcs_Capa === 0) {
                runHour = 0
                runHourTotal = 0
              } else {
                runHour =
                  runData.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
                runHourTotal =
                  runDataTotal.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
                count++
              }
            } else if (runDataTotal.toFixed(1) > 0) {
              runHour = 0
              runHourTotal =
                runDataTotal.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
            } else {
              runHourTotal = 0
              runHour = 0
            }

            datas.push({
              runTime: runTime[index].substr(0, 2) + ':00',
              runData: runData.toFixed(1),
              runDataTotal:
                runData.toFixed(1) > 0 ||
                runTimeRp < day(Date.now()).format('HHmm')
                  ? runDataTotal.toFixed(1)
                  : '0.0',
              runHour: runHour.toFixed(1),
              // runHourTotal: runHourTotal.toFixed(1)
              runHourTotal:
                runData.toFixed(1) > 0 ||
                runTimeRp < day(Date.now()).format('HHmm')
                  ? runHourTotal.toFixed(1)
                  : '0.0'
            })
            runData = 0
          }
        }
        this.barItems = barData
        this.lineItems = lineHours
        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.dayWork = runDataTotal.toFixed(1)
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraMonthWorkTab() {
      let params =
        '?site_id=' +
        this.SITE_ID +
        '&station_id=' +
        this.STATION_ID +
        '&inverter_id=' +
        this.INVERTER_ID +
        '&startDate=' +
        this.startDate
      getSolraInverterMonthWork(params).then(res => {
        let runData = res.solraMonthWork.runData
        let runTime = res.solraMonthWork.runTime
        let datas = []
        let runDataTotal = 0
        let runHourTotal = 0
        let lineHours = []
        let barData = []
        let count = 0 // 0 아닌 데이터 카운트

        for (let i = 0; i < runData.length; i++) {
          runDataTotal = runData[i] + runDataTotal
          let iRunDataTotal = runData[i] > 0 ? runDataTotal : 0
          let irunHour =
            runData[i] / this.unitedSolra.PVPCS_Pcs_Capa
          runHourTotal = irunHour + runHourTotal
          let iRunHourTotal = runData[i] > 0 ? runHourTotal : 0
          lineHours.push(irunHour.toFixed(1))
          barData.push(runData[i].toFixed(1))
          datas.push({
            runTime: runTime[i],
            runData: runData[i].toFixed(1),
            runDataTotal: iRunDataTotal.toFixed(1),
            runHour: irunHour.toFixed(1),
            runHourTotal: iRunHourTotal.toFixed(1)
          })
          if (runData[i] !== 0) {
            count++
          }
        }

        this.barItems = barData
        this.lineItems = lineHours

        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraYearWorkTab() {
      let params =
        '?site_id=' +
        this.SITE_ID +
        '&station_id=' +
        this.STATION_ID +
        '&inverter_id=' +
        this.INVERTER_ID +
        '&startDate=' +
        this.startDate
      getSolraInverterYearWork(params).then(res => {
        let runData = res.solraYearWork.runData
        let runTime = res.solraYearWork.runTime
        let zeroCount = res.solraYearWork.count

        let datas = []
        let runDataTotal = 0
        let runHourTotal = 0
        let lineHours = []
        let barData = []
        let count = 0 // 0 아닌 데이터 카운트

        for (let i = 0; i < runData.length; i++) {
          runDataTotal = runData[i] + runDataTotal

          let month = runTime[i].substring(0, runTime[i].length - 1)
          // let monthDay = day(new Date())
          //   .month(month - 1)
          //   .daysInMonth()

          let iRunDataTotal = runData[i] > 0 ? runDataTotal : 0
          let irunHour =
            runData[i] /
            this.unitedSolra.PVPCS_Pcs_Capa /
            (zeroCount[month - 1] !== 0 ? zeroCount[month - 1] : 1)
          runHourTotal = irunHour + runHourTotal
          let iRunHourTotal = runData[i] > 0 ? runHourTotal : 0
          lineHours.push(irunHour.toFixed(1))
          barData.push(runData[i].toFixed(1))
          datas.push({
            runTime: runTime[i],
            runData: runData[i].toFixed(1),
            runDataTotal: iRunDataTotal.toFixed(1),
            runHour: irunHour.toFixed(1),
            runHourTotal: iRunHourTotal.toFixed(1)
          })
          if (runData[i] !== 0) {
            count++
          }
        }

        this.barItems = barData
        this.lineItems = lineHours

        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraDayWorkTabTotal() {
      let params = '?site_id=' + this.SITE_ID + '&startDate=' + this.startDate
      getSolraDayWork(params).then(res => {
        // this.barItems = res.solraDayWork.runData
        // this.dayWork = res.solraDayWork.sumValData

        let datas = []
        let runDataTotal = 0
        let runData = 0
        let runTime = res.solraDayWork.runTime
        let runHourTotal = 0
        let runHour = 0
        let barData = []
        let lineHours = []
        let count = 0 // 0 아닌 데이터 카운트

        for (let index = 0; index < runTime.length; index++) {
          let runTimeRp = Number(runTime[index].replace(/:/gi, '')) // ex) 05:00 --> 0500
          barData.push(res.solraDayWork.runData[index].toFixed(1))
          runData += res.solraDayWork.runData[index] // 발전량
          runDataTotal += res.solraDayWork.runData[index] // 누적발전량
          lineHours.push((runData / this.unitedSolra.PVPCS_Pcs_Capa).toFixed(1))

          // ex) 05:50, 06:50 등 다음 시간으로 넘어가기 전 push
          // 20.02.06 AHJ 40분 간격으로 변경함에 따라 50->40 변경
          if (runTime[index].substr(3) === '40') {
            // 발전시간 추가
            if (runData.toFixed(1) > 0) {
              if (this.unitedSolra.PVPCS_Pcs_Capa === 0) {
                runHour = 0
                runHourTotal = 0
              } else {
                runHour = runData.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
                // if (runHour === Infinity) {
                //   runHour = 0
                // }
                runHourTotal =
                  runDataTotal.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
                count++
              }
            } else if (runDataTotal.toFixed(1) > 0) {
              runHour = 0
              runHourTotal =
                runDataTotal.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
            } else {
              runHourTotal = 0
              runHour = 0
            }

            datas.push({
              runTime: runTime[index].substr(0, 2) + ':00',
              runData: runData.toFixed(1),
              runDataTotal:
                runData.toFixed(1) > 0 ||
                runTimeRp < day(Date.now()).format('HHmm')
                  ? runDataTotal.toFixed(1)
                  : '0.0',
              runHour: runHour.toFixed(1),
              // runHourTotal: runHourTotal.toFixed(1)
              runHourTotal:
                runData.toFixed(1) > 0 ||
                runTimeRp < day(Date.now()).format('HHmm')
                  ? runHourTotal.toFixed(1)
                  : '0.0'
            })
            runData = 0
          }
        }
        this.barItems = barData
        this.lineItems = lineHours
        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.dayWork = runDataTotal.toFixed(1)
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraMonthWorkTabTotal() {
      let params = '?site_id=' + this.SITE_ID + '&startDate=' + this.startDate
      getSolraMonthWork(params).then(res => {
        let runData = res.solraMonthWork.runData
        let runTime = res.solraMonthWork.runTime
        let datas = []
        let runDataTotal = 0
        let runHourTotal = 0
        let lineHours = []
        let barData = []
        let count = 0 // 0이 아닌 데이터 개수

        for (let i = 0; i < runData.length; i++) {
          runDataTotal = runData[i] + runDataTotal
          let iRunDataTotal = runData[i] > 0 ? runDataTotal : 0
          let irunHour = runData[i] / this.unitedSolra.PVPCS_Pcs_Capa
          runHourTotal = irunHour + runHourTotal
          let iRunHourTotal = runData[i] > 0 ? runHourTotal : 0
          lineHours.push(irunHour.toFixed(1))
          barData.push(runData[i].toFixed(1))
          datas.push({
            runTime: runTime[i],
            runData: runData[i].toFixed(1),
            runDataTotal: iRunDataTotal.toFixed(1),
            runHour: irunHour.toFixed(1),
            runHourTotal: iRunHourTotal.toFixed(1)
          })
          if (runData[i] !== 0) {
            count++
          }
        }

        this.barItems = barData
        this.lineItems = lineHours

        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraYearWorkTabTotal() {
      let params = '?site_id=' + this.SITE_ID + '&startDate=' + this.startDate
      getSolraYearWork(params).then(res => {
        let runData = res.solraYearWork.runData
        let runTime = res.solraYearWork.runTime
        let zeroCount = res.solraYearWork.count

        let datas = []
        let runDataTotal = 0
        let runHourTotal = 0
        let lineHours = []
        let barData = []
        let count = 0 // 0이 아닌 데이터 개수

        for (let i = 0; i < runData.length; i++) {
          runDataTotal = runData[i] + runDataTotal
          let iRunDataTotal = runData[i] > 0 ? runDataTotal : 0 // 누적 발전량

          let month = runTime[i].substring(0, runTime[i].length - 1)
          // let monthDay = day(new Date())
          //   .month(month - 1)
          //   .daysInMonth()

          let irunHour =
            runData[i] /
            this.unitedSolra.PVPCS_Pcs_Capa /
            (zeroCount[month - 1] !== 0 ? zeroCount[month - 1] : 1) // 발전시간
          runHourTotal = irunHour + runHourTotal // 누적 발전시간
          let iRunHourTotal = runData[i] > 0 ? runHourTotal : 0

          // 그래프 데이터
          lineHours.push(irunHour.toFixed(1))
          barData.push(runData[i].toFixed(1))

          // 표 데이터
          datas.push({
            runTime: runTime[i],
            runData: runData[i].toFixed(1),
            runDataTotal: iRunDataTotal.toFixed(1),
            runHour: irunHour.toFixed(1),
            runHourTotal: iRunHourTotal.toFixed(1)
          })

          if (runData[i] !== 0) {
            count++
          }
        }

        this.barItems = barData
        this.lineItems = lineHours

        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    }
  }
}
</script>

<style scoped>
.txt-blue {
  color: #0784f2;
}

.txt-green {
  color: var(--v-txtgreen-base);
}

.workSearchBtn {
  width: 55px;
  height: 28px;
  float: left;
  background-color: #2976d2;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  padding-top: 4px;
}
</style>
